import * as HLF from "html-living-framework";
import {Container} from "../Core/Container";
import {Spine} from "../Core/Spine";
import {Assets} from "../Data/Assets";
import {CaptionToken} from "../Data/CaptionToken";

export class LunaCharacter extends Container {

    public readonly characterSpine: Spine;

    private _isTalking = false;

    get isTalking(): boolean {
        return this._isTalking;
    }

    constructor() {
        super();

        this.characterSpine = this.addChild(new Spine(Assets.luna.getAsset()));

        this.characterSpine.setMixes(0);
        this.characterSpine.autoUpdate = true;
        this.animateIdle();

        PubSub.subscribe(HLF.VOICEOVER_STARTED, this.onPlayCaption);
        PubSub.subscribe(HLF.VOICEOVER_ENDED, this.onStopCaption);

        PubSub.subscribe(HLF.GAME_PAUSED, this.onPause);
        PubSub.subscribe(HLF.GAME_UNPAUSED, this.onResume);
    }

    public startTalk() {
        if (!this._isTalking) {
            this._isTalking = true;
            this.animateTalk();
        }
    }

    public stopTalk() {
        if (this._isTalking) {
            this._isTalking = false;
            this.animateIdle();
        }
    }

    public destroy() {
        PubSub.unsubscribe(this.onPlayCaption);
        PubSub.unsubscribe(this.onStopCaption);
        PubSub.unsubscribe(this.onPause);
        PubSub.unsubscribe(this.onResume);
        super.destroy();
    }

    protected isCharacterCC(id: string) {
        return true;
    }

    protected animateIdle(): void {
        this.characterSpine.animate("update-idle2", -1);
        if (!this.isTalking) {
            this.characterSpine.track(2).animate("update-idle2");
        }
    }

    protected animateTalk(): void {
        this.characterSpine.track(2).animate("update-idle-talking", -1);
    }

    private readonly onPlayCaption = (topic: string, token: CaptionToken) => {
        if (token && this.isCharacterCC(token.id)) {
            this.startTalk();
        } else {
            this.stopTalk();
        }
    }

    private readonly onStopCaption = () => {
        this.stopTalk();
    }

    private readonly onPause = () => {
        this.characterSpine.autoUpdate = false;
    }

    private readonly onResume = () => {
        this.characterSpine.autoUpdate = true;
    }
}
